const GET_COLLECTIONS = "GET_COLLECTIONS";
const GET_COLLECTIONS_SUCCESS = "GET_COLLECTIONS_SUCCESS";
const GET_COLLECTIONS_FAILURE = "GET_COLLECTIONS_FAILURE";
const CLEAR_GET_COLLECTIONS = "CLEAR_GET_COLLECTIONS";

const collectionSymbols = {
  GET_COLLECTIONS_SUCCESS,
  GET_COLLECTIONS_FAILURE,
  GET_COLLECTIONS,
  CLEAR_GET_COLLECTIONS,
};
export default collectionSymbols;
